export enum RecipientInfoStepInputNames {
  RecipientName = 'recipientFullName',
  RecipientEmail = 'recipientEmail',
  RecipientEmailConfirm = 'recipientEmailConfirm',
  AddAsPageOrganizer = 'addAsPageOrganizer',
}
